import "./StatActivity.scss";

import React from "react";
import { inject, observer } from "mobx-react";
import { RouteNode } from "react-router5";

import Frame from "../Frame/Frame";
import PagerAmount from "../../Components/Pager/PagerAmount";
import Pager from "../../Components/Pager/Pager";
import Popup from "../../Components/Popup/Popup";
import RefreshButton from "../../Components/RefreshButton/RefreshButton";
import { STORE_CONFIG } from "../../Store/ConfigStore";
import { ROUTE_STAT_ACTIVITY } from "../../routes";
import {
  STORE_STAT_ACTIVITY,
  SORT_ASC,
  SORT_DESC,
} from "../../Store/StatActivityStore";
import { STORE_AUTH } from "../../Store/AuthStore";
import axios from "axios";
import DatePicker, { registerLocale } from "react-datepicker";
import hu from "date-fns/locale/hu";
registerLocale("hu", hu);
import { formatDate, formatDateOnly, formatNumber } from "../../utility";
import { timeout } from "q";
import XLSX from "xlsx";

import Select from "react-select";
import { SelectStyle, DropdownIndicator } from "../App/select_style";
const deviceOptions = [
  { value: "CAT-1", label: "CAT-1" },
  { value: "CAT-2", label: "CAT-2" },
  { value: "CAT-3", label: "CAT-3" },
  { value: "CAT-4", label: "CAT-4" },
  { value: "CAT-5", label: "CAT-5" },
  { value: "CAT-6", label: "CAT-6" },
  { value: "CAT-7", label: "CAT-7" },
  { value: "CAT-8", label: "CAT-8" },
  { value: "CAT-10", label: "CAT-10" },
  { value: "CAT-11", label: "CAT-11" },
  { value: "CAT-13", label: "CAT-13" },
  { value: "CAT-14", label: "CAT-14" },
  { value: "Terminál-1", label: "Terminál-1" },
  { value: "Terminál-2", label: "Terminál-2" },
  { value: "Terminál-3", label: "Terminál-3" },
  { value: "Terminál-4", label: "Terminál-4" },
  { value: "Terminál-5", label: "Terminál-5" },
  { value: "Terminál-6", label: "Terminál-6" },
];

const SORT_TYPE = "Type";
const SORT_FROM = "From";
const SORT_TO = "To";
const SORT_DURATION = "Duration";
const SORT_DEVICE = "Device";
const SORT_USER = "User";
const SORT_DISTANCE = "Distance";

function Sorter(props) {
  const asc = ["sorter__dir sorter__dir-asc"];
  const desc = ["sorter__dir sorter__dir-desc"];
  if (props.activeDirection === SORT_ASC) {
    asc.push("sorter__dir--active");
  } else if (props.activeDirection === SORT_DESC) {
    desc.push("sorter__dir--active");
  }
  return (
    <div
      className={"sorter" + (props.activeDirection ? " sorter--active" : "")}
    >
      <div className={asc.join(" ")} title="rendezés növekvő sorrendbe" />
      <div className={desc.join(" ")} title="rendezés csökkenő sorrendbe" />
    </div>
  );
}

const TableSearch = inject((stores) => ({
  store: stores.store.get(STORE_STAT_ACTIVITY),
}))(
  observer((props) => {
    const { store } = props;
    const cancelClassname =
      "search-cancel-button" + (store.search.length > 0 ? "" : " hidden");
    return (
      <div className="table-search">
        <div className="table-search__label">Keresés</div>
        {/*<div className="table-search__input-container">      
        <input className="form-input form-input--inline" type="text" name="focus" value={store.search} onChange={e => store.setSearch(e.target.value)} />       
    </div>*/}
        <div className="search-wrapper">
          <input
            className="search-input"
            value={store.search}
            onChange={(e) => store.setSearch(e.target.value)}
          />
          <div className={cancelClassname} onClick={(e) => store.setSearch("")}>
            <i className="fas fa-times"></i>
          </div>
        </div>
      </div>
    );
  })
);

@inject((stores) => ({
  store: stores.store.get(STORE_STAT_ACTIVITY),
  configStore: stores.store.get(STORE_CONFIG),
  authStore: stores.store.get(STORE_AUTH),
  socket: stores.socket,
  router: stores.router,
}))
@observer
class StatActivity extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      popup: "none",
      popupText: "",
      from: null,
      to: null,
    };

    const { store } = this.props;
    store.setSortDirection(SORT_DESC);
    store.setSortField(SORT_FROM);

    this.refresh();
  }
  onClickSort = (field) => () => {
    const { store } = this.props;
    if (store.sortField === field) {
      store.flipSortDirection();
    } else {
      store.setSortField(field);
      store.setSortDirection(SORT_ASC);
    }
  };

  handleDownload() {
    const { store, configStore } = this.props;
    const { sortedItems } = store;

    const merges = [];
    let data = [
      [
        "Azonosító",
        "Gép",
        "Fok",
        "Beszállító",
        "Cikk",
        "Hely",
        "Mennyiség",
        "Összmennyiség",
        "Tisztaság",
        "Csíra",
        "Víz",
        "Létrehozva",
      ],
    ];
    if (store.showTerminated)
      data[0] = data[0].concat(["Megszüntetve", "Művelet"]);

    let rowindex = 1;

    sortedItems.forEach((pallet) => {
      let row = [
        pallet.LotNo + (pallet.SealNum ? " (" + pallet.SealNum + ")" : ""),
        pallet.MachineText,
        pallet.CleaningRateText +
          (pallet.CustomCleaningRate
            ? " (" + pallet.CustomCleaningRate + ")"
            : ""),
        (pallet.Supplier ? pallet.Supplier : "") +
          (pallet.CustomSupplier ? " (" + pallet.CustomSupplier + ")" : ""),
        pallet.ItemName +
          (pallet.CustomItem ? " (" + pallet.CustomItem + ")" : ""),
        pallet.BinCode,
        (pallet.BagType === 2
          ? pallet.BagCount + " x " + pallet.Quantity
          : pallet.Quantity) + " kg",
        pallet.BagCount * pallet.Quantity,
        pallet.QualityPurity ? pallet.QualityPurity + " %" : "",
        pallet.QualityGerm ? pallet.QualityGerm + " %" : "",
        pallet.QualityWater ? pallet.QualityWater + " %" : "",
        pallet.Created,
      ];

      if (store.showTerminated)
        row = row.concat([
          pallet.Terminated,
          configStore.palletstatuses[pallet.Status],
        ]);

      data.push(row);
    });
    //console.log(data, merges)

    var wb = XLSX.utils.book_new();
    var ws = XLSX.utils.aoa_to_sheet(data);
    ws["!merges"] = merges;
    XLSX.utils.book_append_sheet(wb, ws, "Táblázat");

    XLSX.writeFile(wb, "Táblázat_" + formatDateOnly(new Date()) + ".xlsx", {
      bookSST: true,
      compression: true,
    });
  }

  refresh() {
    const { store, socket } = this.props;

    const data = {
      From: store.from ? store.fromFormatted : null,
      To: store.to ? store.toFormatted : null,
    };

    const _this = this;
    socket.emitWithToken("GetStatActivity", data, function (err, data) {
      if (err) {
        console.error(err);
        return;
      }
      console.log(data);
      store.setItems(data);
    });
  }

  componentDidMount() {
    const { route, store, socket } = this.props;
    if (route.params.hasOwnProperty("search")) {
      store.setSearch(route.params.search);
    }
  }

  showPopup = (text) => {
    this.setState({ popup: "show", popupText: text });
  };

  render() {
    const { store, configStore, authStore, route, router, socket } = this.props;
    const { shownItems, sortDirection, sortField, pager, uploading } = store;
    const { itemCount, lastShownItem, firstShownItem } = pager;
    let { name: routeName, params: routeParams } = route;

    let userOptions = Object.values(configStore.users).map((user) => ({
      value: user.Id,
      label: user.Name,
      pin: user.Pin,
    }));
    userOptions = userOptions.filter((user) => user.pin);
    userOptions.sort((a, b) => {
      return a.label ? a.label.localeCompare(b.label) : -1;
    });

    let rows = [];

    shownItems.forEach((activity) => {
      rows.push(
        <tr
          key={activity.Id}
          className={activity.Type === "Belépve" ? "tr-green" : "tr-red"}
        >
          <td className="table-cell">{activity.Type}</td>
          <td className="table-cell">{activity.From}</td>
          <td className="table-cell">{activity.To}</td>
          <td className="table-cell">{activity.Duration}</td>
          <td className="table-cell">{activity.Device}</td>
          <td className="table-cell">{activity.User}</td>
          <td className="table-cell">{activity.Distance}</td>
        </tr>
      );
    });

    return (
      <Frame>
        <div className="table basic-content">
          <div className="table__top">
            <div className="table-pager-amount">
              <PagerAmount
                perPage={pager.perPage}
                onChange={(e) => pager.setPerPage(e.value)}
              />
            </div>
            <div className="table-datepicker-block">
              Időintervallum&nbsp;
              <DatePicker
                className="table input-date form-input"
                dateFormat="yyyy-MM-dd"
                selected={store.from}
                onChange={(date) => {
                  store.setFrom(date);
                  this.refresh();
                }} /*locale='hu'*/
              />
              <div className="separator"></div>
              <DatePicker
                className="table input-date form-input"
                dateFormat="yyyy-MM-dd"
                selected={store.to}
                onChange={(date) => {
                  store.setTo(date);
                  this.refresh();
                }} /*locale='hu'*/
              />
            </div>

            <Select
              className="react-select fixwidth"
              placeholder="Válasszon eszközt..."
              options={deviceOptions}
              onChange={(option) => {
                store.setDevice(option || null);
              }}
              value={store.selectedDevice}
              isClearable={true}
              isSearchable={false}
              styles={SelectStyle}
              components={{ DropdownIndicator }}
            />

            <Select
              className="react-select fixwidth"
              options={userOptions}
              value={store.selectedUser}
              onChange={(option) => {
                store.setUser(option || null);
              }}
              isClearable={true}
              isSearchable={false}
              styles={SelectStyle}
              components={{ DropdownIndicator }}
              placeholder="Válasszon felhasználót..."
            />

            <TableSearch />
            <RefreshButton
              onClick={() => {
                this.refresh();
              }}
            />
          </div>
          <div className="table__content">
            <table>
              <thead>
                <tr>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_TYPE)}
                    >
                      Típus
                      <Sorter
                        activeDirection={
                          sortField === SORT_TYPE ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_FROM)}
                    >
                      Kezdete
                      <Sorter
                        activeDirection={
                          sortField === SORT_FROM ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_TO)}
                    >
                      Vége
                      <Sorter
                        activeDirection={
                          sortField === SORT_TO ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_DURATION)}
                    >
                      Időtartam (óra:perc)
                      <Sorter
                        activeDirection={
                          sortField === SORT_DURATION ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_DEVICE)}
                    >
                      Eszköz
                      <Sorter
                        activeDirection={
                          sortField === SORT_DEVICE ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_USER)}
                    >
                      Felhasználó
                      <Sorter
                        activeDirection={
                          sortField === SORT_USER ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_DISTANCE)}
                    >
                      Raktárban megtett távolság (m)
                      <Sorter
                        activeDirection={
                          sortField === SORT_DISTANCE ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody className="table_body">{rows}</tbody>
            </table>
          </div>
          <div className="table__bottom">
            <div>
              {firstShownItem} - {lastShownItem} találat mutatása {itemCount}{" "}
              közül
            </div>
            <Pager
              routeName={routeName}
              routeParams={routeParams}
              pager={pager}
              onClickPage={(page) => pager.setCurrentPage(page)}
            />
          </div>
        </div>
        {this.state.popup === "none" ? null : (
          <Popup
            key="popup"
            text={this.state.popupText}
            onClickClose={() => this.setState({ popup: "none" })}
          />
        )}
      </Frame>
    );
  }
}

export {
  SORT_ASC,
  SORT_DESC,
  SORT_TYPE,
  SORT_FROM,
  SORT_TO,
  SORT_DURATION,
  SORT_DEVICE,
  SORT_USER,
  SORT_DISTANCE,
};

export default (props) => (
  <RouteNode nodeName={ROUTE_STAT_ACTIVITY}>
    {(routeProps) => <StatActivity {...routeProps} {...props} />}
  </RouteNode>
);
